import React from 'react';
import Truncate from './react-truncate-ext/Truncate';

function TruncatedText(props) {
  const { text, lines, ...rootProps } = props;

  if (!text) {
    return <div {...rootProps} />;
  }

  return (
    <div title={text} style={{ wordBreak: 'break-all' }} {...rootProps}>
      <Truncate lines={lines} wordBreak="" splitIndex={4}>
        {text}
      </Truncate>
    </div>
  );
}

export default TruncatedText;
